<template>
    <CInlineDatePicker :available-years="availableYears" class="BirthDayPicker" v-bind="$attrs" />
</template>

<script setup lang="ts">
import { listYearsBack } from '#shared/utils'
import CInlineDatePicker from '@/components/ui/CInlineDatePicker.vue'
import { computed } from 'vue'

const availableYears = computed(() => {
    return listYearsBack().slice(14)
})
</script>
